<template>
  <v-container>
    <v-card>
      <v-card-title>
        <h4>交易紀錄</h4>
      </v-card-title>
      <v-container>
        <v-form
          ref="searchForm"
          v-model="validSearch"
          @submit.prevent="search"
        >
          <v-row justify="center">
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="searchModel.Model_CarNo"
                :rules="[(v) => !!v || '必填項目']"
                label="車號 (例: AA-1234)"
                maxlength="10"
                @input="(val) => (searchModel.Model_CarNo = val.toUpperCase())"
              ></v-text-field>
            </v-col>
            <!-- <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="searchModel.Model_Phone"
                :rules="[(v) => !!v || '必填項目']"
                label="手機號碼"
                maxlength="10"
              ></v-text-field>
            </v-col> -->
            <v-col
              cols="12"
              md="2"
            >
              <v-btn
                block
                color="primary"
                class="mt-3"
                type="submit"
              >
                查 詢
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>

      <v-card-actions>
        <v-btn
          color="orange"
          @click="remindDialog = true"
        >
          報到地點
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-row class="justify-sm-center mt-3 red--text">『資料只會查詢目前時間以後的預約記錄。』</v-row>
    <v-card
      v-if="showList"
      class="mt-3"
    >
      <v-simple-table>
        <template>
          <thead>
            <tr>
              <th>停放場地</th>
              <th>使用區間</th>
              <th>交易日期</th>
              <th v-if="false">發票號碼</th>
              <th v-if="false">交易狀態</th>
              <th v-if="false">交易金額</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in listData"
              :key="item.Model_ReservedOrderID"
            >
              <td>{{ item.Model_SpaceName }}</td>
              <td>{{ item.Model_StartDate | toDateFormat("YYYY/MM/DD") }} - {{ item.Model_EndDate | toDateFormat("YYYY/MM/DD") }}</td>
              <td>{{ item.Model_InsertDate | toDateFormat("YYYY/MM/DD HH:mm:ss") }}</td>
              <td>
                <!-- <v-btn
                  v-if="item.Mode_OrderIsEdit>0"
                  class="ml-2"
                  block
                  depressed
                  color="error"
                  @click="openEdit(item)"
                >
                  修改個人資料
                </v-btn> -->
                <v-btn
                  block
                  class="ml-2"
                  depressed
                  color="error"
                  @click="openCancel(item)"
                  :disabled="disableCancel(item)"
                >
                  取消預約
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>

    <v-dialog
      v-model="remindDialog"
      max-width="700px"
    >
      <v-card>
        <v-card-text>
          <p class="text-center text-h4">
            場地位置圖
          </p>
          <v-img
            v-if="siteInfo.ParkingReserved_SiteInfoCode"
            :src="require(`@/assets/map_${siteInfo.ParkingReserved_SiteInfoCode}.jpg`)"
          ></v-img>
        </v-card-text>

        <v-card-text v-if="siteInfo.ParkingReserved_SiteInfoCode == 84416">
          <p class="text-center text-h4">
            報到繳費地點P4停車場B1
          </p>
          <v-img src="@/assets/checkin.jpg"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="remindDialog = false"
          >
            關閉
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="invDialog"
      v-model="invDialog"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>發票</v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="invDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text align="center">
          <div ref="print">
            <table
              max-width="400"
              border="0"
              style="padding:10px 0px; border:2px solid #000000"
              class="mt-5 receipt"
            >
              <table
                width="100%"
                border="0"
                style="position:relative;z-index:2"
                cellpadding="8"
              >
                <tbody>
                  <tr>
                    <td
                      height="50"
                      align="center"
                    >
                      <img
                        v-if="invInfo.Model_UpCompanyCode === 337327633"
                        src="@/assets/337327633.png"
                        width="250"
                        height="50"
                        style="vertical-align:middle"
                      >
                      <img
                        v-if="invInfo.Model_UpCompanyCode === 938793560"
                        src="@/assets/938793560.png"
                        width="250"
                        height="50"
                        style="vertical-align:middle"
                      >
                      <img
                        v-if="invInfo.Model_UpCompanyCode === 953387474"
                        src="@/assets/953387474.png"
                        width="250"
                        height="50"
                        style="vertical-align:middle"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      style="font-size:30px; line-height:30px"
                    >
                      電子發票證明聯 (測試用)
                    </td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      style="font-size:30px; line-height:30px"
                    >
                      <b style=" margin:0px 3px 0px 0px">{{invInfo.Model_InvMon | subStr(0, 3)}}</b>年<span style="padding:0px 3px"> <b style="padding:0px 3px 0px 0px">{{invInfo.Model_InvMon | subStr(3, 5)}}</b>-<b style="padding:0px 0px 0px 3px">{{invInfo.Model_InvMon | subStr(5, 7)}}</b></span>月
                    </td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      style="font-size:30px; line-height:30px"
                    >
                      <b>{{invInfo.Model_Invoice | subStr(0, 2)}}</b>-<b>{{invInfo.Model_Invoice | subStr(2)}}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline"><span style="margin:0px 5px 0px 0px">{{ invInfo.Model_InvDate | toDateFormat("YYYY-MM-DD HH:mm:ss")}}</span> </td>
                            <td
                              v-if="invInfo.Model_BuyerNum"
                              valign="baseline"
                              align="right"
                            >
                              格式 25
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">隨機碼：<span style="font-size:20px; line-height:20px">{{ invInfo.Model_InvGuiNo }}</span></td>
                            <td
                              valign="baseline"
                              align="right"
                            >
                              總計：<span id="totalPrice">$ {{ invInfo.Model_InvPrice | toThousandFilter }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">賣方：<span style="font-size:20px; line-height:20px">{{ invInfo.Model_SellerNum }}</span></td>
                            <td
                              v-if="invInfo.Model_BuyerNum"
                              valign="baseline"
                              align="right"
                            >
                              買方：<span style="font-size:20px; line-height:20px">{{ invInfo.Model_BuyerNum }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td align="center">
                      <vue-barcode
                        :value="invInfo.Model_BarCode"
                        :width="barcodeOpts.width"
                        :height="barcodeOpts.height"
                        :format="barcodeOpts.format"
                        :displayValue="false"
                      />
                    </td>
                  </tr>
                  <tr
                    class="paddingTop"
                    id="paddingTop"
                  >
                    <td></td>
                  </tr>
                  <tr>
                    <td
                      id="qrCodeArea"
                      valign="baseline"
                      align="center"
                    >
                      <qrcode-vue
                        :value="invInfo.Model_QRCodeLeft"
                        size="150"
                        level="L"
                        style="display:inline; margin:0px 50px 0px 0px"
                      />

                      <qrcode-vue
                        :value="invInfo.Model_QRCodeRight"
                        size="150"
                        level="L"
                        style="display:inline;"
                      />
                    </td>
                  </tr>
                  <tr
                    class="paddingBottom"
                    id="paddingBottom"
                  >
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">機: <span style="font-size:20px; line-height:20px">{{ invInfo.Model_MachineSetSerial }}</span></td>
                            <td
                              v-if="invInfo.Model_BuyerNum"
                              valign="baseline"
                              align="right"
                            >
                              場: <span style="font-size:20px; line-height:20px">{{ invInfo.Model_SiteSerial }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td height="30">
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td
                      height="50"
                      align="center"
                      style="font-size:30px; line-height:30px"
                    >
                      銷 貨 明 細 表
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline"><span style="margin:0px 5px 0px 0px">{{ invInfo.Model_UpCompanyName}}</span> </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">{{ invInfo.Model_ComName}}<span style="margin:0px 5px 0px 0px">({{ invInfo.Model_SiteName}})</span> </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">地址: <span style="margin:0px 5px 0px 0px">{{ invInfo.Model_SiteAddress}}</span> </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">電話: <span style="margin:0px 5px 0px 0px">{{ invInfo.Model_SiteTel}}</span> </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">機: <span style="margin:0px 5px 0px 0px">{{ invInfo.Model_MachineSetSerial}}</span> </td>

                            <td
                              valign="baseline"
                              align="right"
                            >
                              序: <span style="margin:0px 5px 0px 0px">{{ invInfo.Model_PayNo}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">收費項目: <span style="margin:0px 5px 0px 0px">{{ invInfo.Model_ChargeItemsName}}</span> </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">交易日: <span style="margin:0px 5px 0px 0px">{{ invInfo.Model_InvDate | toDateFormat("YYYY-MM-DD HH:mm:ss") }}</span> </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">發票日: <span style="margin:0px 5px 0px 0px">{{ invInfo.Model_InvDate | toDateFormat("YYYY-MM-DD HH:mm:ss") }}</span> </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr
                    class="paddingBottom"
                    id="paddingBottom"
                  >
                    <td></td>
                  </tr>
                  <tr
                    v-for="(item, index) in invInfo.List_Receipt"
                    :key="index"
                  >
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline"><span style="margin:0px 20px 0px 0px">{{ item.Receipt_ItemName }}</span> </td>

                            <td
                              valign="baseline"
                              align="center"
                            >
                              <span>${{ item.Receipt_UnitPrice | toThousandFilter }} * {{  item.Receipt_Quantity }}</span>
                            </td>

                            <td
                              valign="baseline"
                              align="right"
                            >
                              <span>{{ item.Receipt_UnitPrice*item.Receipt_Quantity | toThousandFilter}} </span> TX
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr
                    class="paddingBottom"
                    id="paddingBottom"
                  >
                    <td></td>
                  </tr>
                  <tr>
                    <td height="30">
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline"><span style="font-size:20px; line-height:20px">發票金額</span></td>
                            <td
                              valign="baseline"
                              align="right"
                            >
                              <span id="totalPrice">${{ invInfo.Model_InvPrice | toThousandFilter }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline"><span style="font-size:20px; line-height:20px">含稅金額</span></td>
                            <td
                              valign="baseline"
                              align="right"
                            >
                              <span id="totalPrice">${{ invInfo.Model_InvPrice | toThousandFilter }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline"><span style="font-size:20px; line-height:20px">未稅金額</span></td>
                            <td
                              valign="baseline"
                              align="right"
                            >
                              <span id="totalPrice">${{ invInfo.Model_InvNoTaxPrice | toThousandFilter }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline"><span style="font-size:20px; line-height:20px">稅額</span></td>
                            <td
                              valign="baseline"
                              align="right"
                            >
                              <span id="totalPrice">${{ invInfo.Model_InvTaxPrice | toThousandFilter }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td valign="baseline">備註: <span style="margin:0px 5px 0px 0px">{{ invInfo.Model_InvInfoMemo}}</span> </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </table>
          </div>
          <div class="mt-5">
            <v-btn
              elevation="2"
              large
              :disabled="downloadIng"
              color="primary"
              @click="printOut()"
            >{{ downloadIng ? '下載中' : '檔案下載' }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="cancelDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          是否確定取消預約?
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="cancelDialog = false"
          >
            否
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="cancelOrder()"
          >
            是
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editDialog"
      persistent
      width="600px"
    >
      <v-card>
        <v-card-title class="text-h5 font-weight-bold grey lighten-2">
          訂單資料修改
          <v-spacer />
          <v-btn
            icon
            @click="editDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form
            class="mt-5"
            ref="editeForm"
            v-model="validEdit"
          >
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="editModel.Model_Contact"
                  :rules="[(v) => !!v || '必填項目']"
                  label="姓名"
                  maxlength="50"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="editModel.Model_CarShow"
                  :rules="[(v) => !!v || '必填項目', (v) => /^((軍[A-Z]-[0-9]{5})|([A-Z0-9]{1,4}-[A-Z0-9]{1,4}))$/.test(v) || '車號規格錯誤']"
                  label="車牌號碼 (例: AA-1234)"
                  maxlength="10"
                  @input="(val) => (editModel.Model_CarShow = val.toUpperCase())"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="editModel.Model_Phone"
                  :rules="[(v) => !!v || '必填項目', (v) => /^(09[0-9]{8})$/.test(v) || '手機格式錯誤']"
                  label="手機號碼"
                  maxlength="10"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="editDialog = false"
          >
            關閉
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="goEdit"
          >
            送出
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          right
          bottom
          color="success"
          v-bind="attrs"
          v-on="on"
          @click="$router.go(-1)"
        >
          <v-icon>mdi-keyboard-return</v-icon>
        </v-btn>
      </template>
      <span>返回</span>
    </v-tooltip>
  </v-container>
</template>

<style scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
td {
  min-width: 80px !important;
}

@media (max-width: 400px) {
  .vue-barcode-element {
    width: 228px;
    height: 60px;
  }
}
</style>
<script>
import QrcodeVue from 'qrcode.vue';
import VueBarcode from 'vue-barcode';
import html2canvas from 'html2canvas';

export default {
  name: 'OrderRecord',
  components: {
    QrcodeVue,
    VueBarcode
  },
  data: () => ({
    validSearch: false,
    searchModel: {
      Model_CarNo: null,
      Model_SiteCode: null
    },
    showList: false,
    listData: [],
    remindDialog: false,
    invDialog: false,
    invInfo: {},
    barcodeOpts: {
      width: 1,
      height: 50,
      format: 'CODE39'
    },
    downloadIng: false,
    siteID: null,
    siteInfo: {},
    cancelDialog: false,
    cancelModel: {},
    editDialog: false,
    validEdit: false,
    editModel: {}
  }),
  computed: {},
  watch: {},
  created() {
    if (!this.$route.params.id) {
      this.msg('查無指定場地', 2000);
      this.$router.replace('/');
    }

    this.dbio('/ParkingOnlyReserved/GetReservedSpace', {
      LinkID: this.$route.params.id
    }).then((response) => {
      this.siteID = this.$route.params.id;
      this.siteInfo = response.ParkingReserved;
      this.searchModel.Model_SiteCode =
        this.siteInfo.ParkingReserved_SiteInfoCode;
    });
  },
  mounted() {},
  methods: {
    search() {
      this.$refs.searchForm.validate();
      if (this.validSearch) {
        this.dbio('/ParkingOnlyReserved/GetOrderRecord', this.searchModel).then(
          (response) => {
            this.listData = response;
            this.showList = true;
          }
        );
      }
    },
    disableCancel(order) {
      if (order.Model_PayState == 1) {
        return true;
      }

      if (new Date(order.Model_StartDate) <= new Date()) {
        return true;
      }

      return false;
    },
    openCancel(order) {
      this.cancelModel = order;
      this.cancelDialog = true;
    },
    cancelOrder() {
      this.dbio('/ParkingOnlyReserved/OrderCancel', {
        OrderID: this.cancelModel.Model_ReservedOrderID,
        Model_CarNo: this.searchModel.Model_CarNo,
      }).then(() => {
        this.msg('已取消該時段的預約', 3000);
        this.cancelDialog = false;
        this.search();
      });
    },
    openEdit(order) {
      this.dbio('/ParkingOnlyReserved/GetOrderDetail', {
        OrderID: order.Model_ReservedOrderID,
        Model_CarNo: this.searchModel.Model_CarNo,
      }).then((res) => {
        this.editDialog = true;
        this.editModel = res;
      });
    },
    printOut() {
      this.downloadIng = true;
      this.downloadImage();
    },
    goEdit() {
      this.$refs.editeForm.validate();
      if (this.validEdit) {
        this.dbio(
          '/ParkingOnlyReserved/EditOrder',
          this.editModel,
          'post'
        ).then(() => {
          this.editDialog = false;
          this.search();
        });
      }
    },
    downloadImage() {
      html2canvas(this.$refs.print).then((canvas) => {
        let link = document.createElement('a');
        link.href = canvas.toDataURL();
        link.setAttribute('download', '發票資訊.png');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        this.downloadIng = false;
      });
    }
  }
};
</script>
